import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; {new Date().getFullYear()} Logan Dracos/Ethan Waggoner</p>
    </footer>
  );
};

export default Footer;